import { Box } from "@rebass/grid";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Banner,
  ESpacings,
  MultiStepForm,
} from "@rentiohq/web-shared/dist/components";
import createSchema from "../../../forms/tenantProfileBroker";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  performingSubmitActionResultSelector,
  submitActionCreator,
} from "../../../forms/tenantProfileBroker/schema.tenantProfileBroker.actions";

const formId = generateFormId();

const TenantProfilePreferences = () => {
  const { broker } = authHooks.useSelf();

  const renderContent = () => {
    if (!broker) {
      return null;
    }

    return (
      <>
        <Box mb={ESpacings.loose}>
          <Banner
            hasDismiss={false}
            icon="contentPenWrite"
            title={getLocalizedText("broker.tenant_profile.info.heading")}
          />
        </Box>
        <MultiStepForm
          formId={`update-broker-${formId}`}
          schemas={createSchema({ broker })}
          withAside={false}
          isPerformingSubmitActionSelector={isPerformingSubmitActionSelector(
            broker.id,
          )}
          performingSubmitActionResultSelector={performingSubmitActionResultSelector(
            broker.id,
          )}
          performingSubmitActionErrorSelector={performingSubmitActionErrorSelector(
            broker.id,
          )}
          submitActionCreator={submitActionCreator(broker.id)}
          submitLabel={getLocalizedText("system.save")}
        />
      </>
    );
  };

  return renderContent();
};

// eslint-disable-next-line import/no-default-export
export default TenantProfilePreferences;
